import { useEffect, useState, useMemo, useCallback } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { useSidebarStore } from '~/store/sidebar'
import useAuth from '~/utils/auth/useAuth'
import useBoolean from '~/utils/hooks/useBoolean'
import useScreenMobile from '~/utils/hooks/useScreenMobile'

const useCustom = () => {
  const { isPermissionGranted } = useAuth()
  const history = useHistory()
  const location = useLocation()
  const { detail, id } = useParams<any>()
  const isMobile = useScreenMobile()

  const { toggleSidebar } = useSidebarStore()

  const [open, setOpen] = useState(true)
  const toggleMobileDrawer = useBoolean()

  const [currentPath, setPath] = useState('')

  const handleDrawer = () => {
    setOpen(!open)
    toggleSidebar()
  }
  const pushHistory = useCallback(
    (path) => {
      history.push(path)

      if (isMobile) {
        toggleMobileDrawer.toggle()
      }
    },
    [toggleMobileDrawer, isMobile]
  )

  const firstPath = useMemo(() => location.pathname.split('/')[1], [location])

  useEffect(() => {
    setPath(location.pathname)
  }, [location])

  return {
    data: {
      currentPath,
      detail,
      firstPath,
      id,
      open,
      toggleMobileDrawer,
    },
    methods: {
      handleDrawer,
      isPermissionGranted,
      pushHistory,
    },
  }
}

export default useCustom
